import React from 'react';
import styles from './BusinessTechnicalSolution.module.scss';
import CircleIcon from '../CircleIcon/CircleIcon';

const BusinessTechnicalSolution = ({ data }) => {
  return (
    <div
      data-testid={'technical-solution'}
      className={styles.container}
      itemScope
      itemType='https://schema.org/Service'
    >
      <div className={styles.top}>
        {data?.icon && (
          <div className={styles['icon-wrapper']}>
            <CircleIcon small path={data.icon} alt={data.icon.alt} />
          </div>
        )}
        {data?.title && <span className={styles.title}>{data.title}</span>}
      </div>
      <span
        className={styles.list}
        dangerouslySetInnerHTML={{
          __html: data?.description,
        }}
      ></span>
    </div>
  );
};

export default BusinessTechnicalSolution;
